'use client';

import React, { useState } from 'react';
import CalculatorForm from './CalculatorForm';
import ResultsDisplay from './ResultsDisplay';
import ImpactVisualization from './ImpactVisualization';
import DisposalSolutions from './DisposalSolutions';

interface CalculationResult {
  microfibers: number;
  severity: 'low' | 'medium' | 'high' | 'critical';
  annualImpact: number;
  equivalentBottles: number;
}

const CalculatorHubInteractive = () => {
  const [calculationResult, setCalculationResult] = useState<CalculationResult | null>(null);
  const [currentFabricType, setCurrentFabricType] = useState('');

  const handleCalculate = (result: CalculationResult) => {
    setCalculationResult(result);
  };

  return (
    <div data-component-id="src/app/calculator-hub/components/CalculatorHubInteractive.tsx:25:4" data-component-path="src/app/calculator-hub/components/CalculatorHubInteractive.tsx" data-component-line="25" data-component-end-line="35" data-component-file="CalculatorHubInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-8%22%7D" className="space-y-8">
      <CalculatorForm data-component-id="src/app/calculator-hub/components/CalculatorHubInteractive.tsx:26:6" data-component-path="src/app/calculator-hub/components/CalculatorHubInteractive.tsx" data-component-line="26" data-component-end-line="26" data-component-file="CalculatorHubInteractive.tsx" data-component-name="CalculatorForm" data-component-content="%7B%22elementName%22%3A%22CalculatorForm%22%7D" onCalculate={handleCalculate} />
      
      {calculationResult && (
        <>
          <ResultsDisplay data-component-id="src/app/calculator-hub/components/CalculatorHubInteractive.tsx:30:10" data-component-path="src/app/calculator-hub/components/CalculatorHubInteractive.tsx" data-component-line="30" data-component-end-line="30" data-component-file="CalculatorHubInteractive.tsx" data-component-name="ResultsDisplay" data-component-content="%7B%22elementName%22%3A%22ResultsDisplay%22%7D" result={calculationResult} />
          <ImpactVisualization data-component-id="src/app/calculator-hub/components/CalculatorHubInteractive.tsx:31:10" data-component-path="src/app/calculator-hub/components/CalculatorHubInteractive.tsx" data-component-line="31" data-component-end-line="31" data-component-file="CalculatorHubInteractive.tsx" data-component-name="ImpactVisualization" data-component-content="%7B%22elementName%22%3A%22ImpactVisualization%22%7D" result={calculationResult} />
          <DisposalSolutions data-component-id="src/app/calculator-hub/components/CalculatorHubInteractive.tsx:32:10" data-component-path="src/app/calculator-hub/components/CalculatorHubInteractive.tsx" data-component-line="32" data-component-end-line="32" data-component-file="CalculatorHubInteractive.tsx" data-component-name="DisposalSolutions" data-component-content="%7B%22elementName%22%3A%22DisposalSolutions%22%7D" />
        </>
      )}
    </div>
  );
};

export default CalculatorHubInteractive;